import { useRPilotConfig } from './useRPilotConfig.js'
import { createT } from '../i18n/index.js'

/**
 * Widget-local translation: `const { t } = useI18n()` then `t('chat.send')`.
 * The locale comes from plugin config (host iframe passes ?locale=…). It is
 * fixed for the lifetime of a mount — the host recreates the iframe when the
 * user changes language — so `t` is deliberately non-reactive.
 */
export function useI18n() {
  const cfg = useRPilotConfig()
  return { t: createT(cfg?.locale) }
}
